import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import {BrowserRouter as Router, Link} from "react-router-dom";
import Helmet from "react-helmet";
import ErrorMessage from "../../components/ErrorMessage";
import {config} from "../../components/Constants";
import SearchBar from "../../components/SearchBar";

class ClientsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            isLoggedIn: false,
            isSearching: false,
            clients: []
        };
        this.searchClients = this.searchClients.bind(this);
    }

    componentDidMount() {
        fetch(config.API_URL + '/api/clients', {
            credentials: 'include'
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.error) {
                        this.setState({
                            clients: [],
                            isLoaded: true,
                            error: result.error
                        });
                    } else if (result) {
                        this.setState({
                            clients: result.clients,
                            isLoaded: true
                        });
                    }
                },
                (error) => {
                    this.setState({
                        clients: [],
                        isLoaded: true,
                        error: error
                    });
                }
            )
    }

    searchClients(searchText) {
        this.setState({
            isSearching: true
        });
        fetch(config.API_URL + '/api/clients', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            'method': 'POST',
            'body': JSON.stringify({name: searchText})
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.error) {
                        this.setState({
                            clients: [],
                            isSearching: false,
                            error: result.error
                        });
                    } else if (result) {
                        this.setState({
                            clients: result.clients,
                            isSearching: false
                        });
                    }
                },
                (error) => {
                    this.setState({
                        clients: [],
                        isSearching: false,
                        error: error
                    });
                }
            )

    }

    render() {
        const {error, isLoaded, isLoggedIn, clients, isSearching} = this.state;
        const that = this;
        if (!isLoaded) {
            return (
                <LoadingSpin/>
            );
        } else if (error) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
                    {
                        'title': 'Powrót', 'callback': function () {
                            that.setState({redirect: '/clients', error: null});
                        }
                    }
                ]} handleClose={() => {
                    that.setState({redirect: '/clients', error: null});
                }}/>
            );
        } else {
            return (
                <React.Fragment>
                    <Helmet>
                        <title>Lista obiektów</title>
                    </Helmet>
                    <header className="clients-header">
                        <h1>Lista obiektów</h1>
                        <SearchBar onSearch={this.searchClients} label="Wyszukaj klienta po nazwie lub subdomenie"/>
                    </header>
                    <div className="section-div">
                        {!isSearching ?
                        <table className="data">
                            <thead id="tableHead">
                            <tr>
                                <th className="center">ID</th>
                                <th>Nazwa obiektu</th>
                                <th>Subdomena</th>
                                <th>Status</th>
                                <th className="center"><i className="fas fa-globe" title="Web"></i></th>
                                <th className="center"><i className="fas fa-handshake" title="CRM"></i></th>
                                <th className="center"><i className="fas fa-star" title="Event"></i></th>
                                <th className="center"><i className="fas fa-chart-line" title="Management"></i></th>
                                <th className="center"><i className="fas fa-envelope" title="Comm"></i></th>
                                <th className="center"><i className="fas fa-mobile-alt" title="Mobile"></i></th>
                                <th className="center"><i className="fas fa-bed" title="Corpo"></i></th>
                                <th className="center"><i className="fas fa-gift" title="Voucher"></i></th>
                                <th className="center"><i className="fas fa-tv" title="HI Media"></i></th>
                                <th className="center"><i className="fas fa-cubes" title="Place"></i></th>
                                <th className="center"><i className="fas fa-clipboard-list" title="Production"></i></th>
                                <th className="center"><i className="fab fa-wpforms" title="Project"></i></th>
                                <th className="center"><i className="fas fa-exchange-alt" title="Extranet"></i></th>
                                <th className="center" colSpan="4">Akcje</th>
                            </tr>
                            </thead>
                            <tbody>
                            {clients ? clients.map((client, mkey) => {
                                return (
                                    <tr key={mkey}>
                                        <td className="center">{client.id}</td>
                                        <td>{client.nazwa}</td>
                                        <td><a href={'https://' + client.subd + '.sim.horecaidea.pl/'} target="_blank">{client.subd}</a></td>
                                        <td>{client.status}</td>
                                        <td className="center">
                                            {client.web_aplikacja > 0 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_crm === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_event === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_management === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_poczta === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_mobile === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_corpo === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_vouchery === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_himedia === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_loze === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_karta_eventu === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_karta_projektu === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center">
                                            {client.czy_najemca === 1 ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>}
                                        </td>
                                        <td className="center actions">
                                            <Link to={'/clients/edit/' + client.id}><i className="fas fa-edit" title="Edytuj"></i></Link>
                                        </td>
                                        <td className="center actions">
                                            <Link to={'/clients/users/' + client.id}><i className="fas fa-user-edit" title="Użytkownicy"></i></Link>
                                        </td>
                                        <td className="center actions">
                                            <Link to={'/clients/analytics/' + client.id}><i className="fas fa-chart-bar" title="Analityka"></i></Link>
                                        </td>
                                        <td className="center actions">
                                            <Link to={'/clients/delete/' + client.id}><i className="fas fa-trash-alt" title="Usuń"></i></Link>
                                        </td>
                                    </tr>
                                )
                            }) :
                            <tr>
                                <td colSpan={13}>
                                    Brak załadowanych obiektów
                                </td>
                            </tr>
                            }
                            </tbody>
                        </table> : <LoadingSpin/>}
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default ClientsList;
